import { render, staticRenderFns } from "./ProductSegmentDialog.vue?vue&type=template&id=21737cee&scoped=true"
import script from "./ProductSegmentDialog.vue?vue&type=script&lang=ts"
export * from "./ProductSegmentDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProductSegmentDialog.vue?vue&type=style&index=0&id=21737cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21737cee",
  null
  
)

export default component.exports